<template>
  <section class="testimonialsSection" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="testimonialsSection__bg">
      <div class="testimonialsSection__images js-section-slider-testimonials-images">
        <img v-for="(story, index) in stories" :key="index" :src="story.photo" alt="image" />
      </div>
      <div style="background-color: var(--c-section_primary)"></div>
    </div>

    <div class="container">
      <div class="row justify-end">
        <div class="col-xl-5 col-lg-6 col-md-7">
          <div class="testimonialsSection__content layout-pt-lg layout-pb-lg lg:tw-justify-center lg:tw-gap-y-16" >
            
             <div v-html="vars.titleHtml" ></div>
            <div class="relative overflow-hidden js-section-slider-testimonials">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(story, index) in stories" :key="index">
                  <library-image image-class="tw-mb-4 md:tw-hidden" :src="story.photo" :alt="story.title" />
                  <h5>{{ story.title }}</h5>
                  <p class="mt-4">{{ story.description }}</p>
                  <button :class="`n-${story.button_type}`" class="mt-4 tw-mt-auto">
                    {{ story.button_label }}
                  </button>
                </div>
              </div>
            </div>

            <div class="d-flex mt-30">
              <button class="sliderNav -prev -transparent js-section-slider-testimonials-prev">
                <i class="icon-left-arrow"></i>
              </button>
              <button class="sliderNav -next -transparent ml-20 js-section-slider-testimonials-next">
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme8StoryBox',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
      },
    };
  },

  computed: {
    stories() {
      return this.groupedVariables?.stories || [];
    },
  },
});
</script>
